export default __webpack_public_path__ + "static/media/tomoscan-logo-dark.3eabd0d2.svg";